import { HttpInterceptorFn } from '@angular/common/http';
import { Loader } from '../Services/Themes/loader';
import { inject } from '@angular/core';
import { catchError, finalize, of, timeout, throwError } from 'rxjs';

// URL substrings whose requests should NOT trigger the global skeleton.
// Auth/token bootstrap is invisible by design; telemetry log writes are
// fire-and-forget and shouldn't block UI.
const SKIP_LOADER_PATTERNS = [
  'auth',
  'token',
  'AddUpdatePatientPortalLogs',
  'PatientPortalLogs',
];

// Watchdog: any request that takes longer than this is treated as stalled.
// finalize() fires on the timeout error, so the loader ref-count is released
// and the UI can never get permanently stuck behind a hung request.
const REQUEST_WATCHDOG_MS = 120_000;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(Loader);

  if (SKIP_LOADER_PATTERNS.some(p => req.url.includes(p))) {
    return next(req);
  }

  loader.show();

  return next(req).pipe(
    timeout(REQUEST_WATCHDOG_MS),
    catchError(err => {
      // Surface the error to downstream handlers (auth interceptor, component
      // subscribe blocks). The loader is released by finalize() regardless.
      if (err?.name === 'TimeoutError') {
        console.warn(`[loader-interceptor] request exceeded ${REQUEST_WATCHDOG_MS}ms, releasing loader`, req.url);
      }
      return throwError(() => err);
    }),
    finalize(() => loader.hide())
  );
};
